var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "progress-button",
    {
      staticClass: "m-button-context m-button-save",
      class: _vm.classes,
      attrs: { disabled: _vm.disabled, loading: _vm.state === 1 }
    },
    [
      _c(
        "span",
        { staticClass: "m-button-context__text" },
        [_vm._t("default", [_vm._v("Save")])],
        2
      ),
      _vm._v(" "),
      _c("mom-icon", {
        key: "save",
        staticClass: "m-button-context__action",
        attrs: { svgIcon: "save" }
      }),
      _vm._v(" "),
      _c("mom-icon", {
        key: "check",
        staticClass: "m-button-save__success",
        attrs: { svgIcon: "check" }
      }),
      _vm._v(" "),
      _c("mom-icon", {
        key: "error",
        staticClass: "m-button-save__error",
        attrs: { svgIcon: "error-outline" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }